import { Text, Heading, LiliButton, FontWeight } from '@lili/lili-frontend-common';
import LiliLogo from '@Assets/logos/lili-logo-blue.svg';
import WelcomeRankingBanner from '@Assets/banners/welcome-ranking.svg';
import { AuthorizedUserType } from '@Store/slices/authOnboarding/authOnboarding.types';
import { useTranslation } from 'react-i18next';
import { useNavigationManager } from '@Router/useNavigationManager';
import { useBoundStore } from '@Store/useBoundStore';

export const InviteTeamMemberIntro = () => {
  const {
    customerFirstName: customerName,
    customerBusinessName: businessName,
    authorizedUserType: flow,
  } = useBoundStore.getState().authOnboardingSlice;
  const { t } = useTranslation('inviteTeamMember');
  const { navigateToNextPage } = useNavigationManager();

  const getDescriptionByFlow = () => {
    if (flow === AuthorizedUserType.ACCOUNTANT) {
      return t('inviteTeamMemberIntro.inviteMessage', { customerName, businessName });
    }
    return t('inviteTeamMemberIntro.inviteMessageAdmin', { customerName, businessName });
  };

  return (
    <div className='flex flex-col items-center justify-center w-full'>
      <div className='flex flex-col items-center mt-[240px] min-h-screen md:max-w-[450px] max-w-[340px]'>
        <img
          src={LiliLogo}
          alt={t('inviteTeamMemberIntro.logoAlt')}
          className='w-[94px] justify-self-center mb-[24px]'
        />
        <div className='flex flex-col text-center w-full items-center gap-[52px]'>
          <div>
            <Heading.H3 fontWeight={FontWeight.SEMIBOLD} className='mb-[4px]'>
              {t('inviteTeamMemberIntro.welcomeHeader')}
            </Heading.H3>
            <Heading.H7>{t('inviteTeamMemberIntro.welcomeSubheader')}</Heading.H7>
          </div>

          <Text.H9 className='text-text-main-secondary'>{getDescriptionByFlow()}</Text.H9>

          <LiliButton
            id='get-started-button'
            title={t('inviteTeamMemberIntro.getStarted')}
            onClick={navigateToNextPage}
          />
        </div>
      </div>
      <div className='flex flex-row gap-4 items-center absolute bottom-[40px] left-1/2 -translate-x-1/2'>
        <img
          className='w-[320px]'
          src={WelcomeRankingBanner}
          alt={t('inviteTeamMemberIntro.trustPilotAlt')}
        />
      </div>
    </div>
  );
};

export default InviteTeamMemberIntro;
